import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import { buildGlossaryTermSeo } from "@/lib/seo/glossaryJsonLd";
import GlossaryTermPage from "@/pages/GlossaryTerm";

const HUB = "/es/recursos/glosario";

export const Route = createFileRoute("/es/recursos/glosario/$slug")({
  head: ({ params }) => {
    const seo = buildGlossaryTermSeo("es", HUB, params.slug);
    return {
      ...buildRouteHead(`${HUB}/${params.slug}`, {
        title: seo.title,
        description: seo.description,
        noIndex: seo.noIndex,
      }),
      scripts: seo.scripts,
    };
  },
  component: GlossaryTermPage,
});
